import { useState } from "react";
import { Drawer, IconButton, Tooltip } from "@mui/material";
import DescriptionIcon from "@mui/icons-material/Description";
import ProposalFormContent from "./ProposalFormContent";

interface ProposalButtonProps {
  selectedItems: Array<{
    option_id: string;
    start_time_id: string;
    date: string;
    tour_group_id: string;
    product_id: string;
  }>;
  entities: any;
}

const ProposalButton = ({ selectedItems, entities }: ProposalButtonProps) => {
  const [openDrawer, setOpenDrawer] = useState<boolean>(false);

  const handleOpenProposal = (e: React.MouseEvent) => {
    e.stopPropagation();
    setOpenDrawer(true);
  };

  const handleCloseDrawer = (e: React.MouseEvent) => {
    e.stopPropagation();
    setOpenDrawer(false);
  };

  return (
    <>
      <Tooltip title="Open proposal form" placement="left" arrow>
        <IconButton
          onClick={handleOpenProposal}
          size="large"
          sx={{
            backgroundColor: "#90ee90",
            color: "#000",
            "&:hover": {
              backgroundColor: "#7cdf7c",
            },
          }}
        >
          <DescriptionIcon />
        </IconButton>
      </Tooltip>

      <Drawer open={openDrawer} onClose={handleCloseDrawer}>
        <ProposalFormContent
          selectedItems={selectedItems}
          entities={entities}
          onClose={handleCloseDrawer}
        />
      </Drawer>
    </>
  );
};

export default ProposalButton;
